import { render, staticRenderFns } from "./zadarmacalls.vue?vue&type=template&id=c6871de8&"
import script from "./zadarmacalls.vue?vue&type=script&lang=js&"
export * from "./zadarmacalls.vue?vue&type=script&lang=js&"
import style0 from "./zadarmacalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports